import { ReactElement } from 'react'
import { useParams } from 'react-router'
import { ProjectPermissions } from 'src/screens/shared/project/permissions/ProjectPermissions'

export const PfPgvPermissionsPage = (): ReactElement => {
  const { projectId } = useParams()
  const pf_pgv_id = parseInt(projectId as string)
  return <ProjectPermissions baseUrl="/pf-pgv" projectId={pf_pgv_id} />
}
